module.exports = function extractName(dto) {
    if(!dto)
        return undefined;

    return dto.Name;
};
